export const FETCH_INITIAL_DATA = 'FETCH_INITIAL_DATA';
export const FETCH_INITIAL_DATA_SUCCESS = 'FETCH_INITIAL_DATA_SUCCESS';
export const FETCHING_ERROR = 'FETCHING_ERROR';
export const FETCH_PROVISIONS = 'FETCH_PROVISIONS';
export const FETCH_PROVISIONS_SUCCESS = 'FETCH_PROVISIONS_SUCCESS';
export const FETCH_PROVISIONS_FAILURE = 'FETCH_PROVISIONS_FAILURE';
export const SET_COMPANY_CODES_FILTER = 'SET_COMPANY_CODES_FILTER';
export const UNSET_COMPANY_CODES_FILTER = 'UNSET_COMPANY_CODES_FILTER';
export const FETCH_PROVISION_DATA = 'FETCH_PROVISION_DATA';
export const FETCH_PROVISION_DATA_SUCCESS = 'FETCH_PROVISION_DATA_SUCCESS';
export const FETCH_PROVISION_DATA_FAILURE = 'FETCH_PROVISION_DATA_FAILURE';
export const SELECT_COMPANY_CODE = 'SELECT_COMPANY_CODE';
export const SELECT_PERIOD = 'SELECT_PERIOD';
export const FETCH_TAX_YEARS = 'FETCH_TAX_YEARS';
export const FETCH_TAX_YEARS_SUCCESS = 'FETCH_TAX_YEARS_SUCCESS';
export const FETCH_PERIODS = 'FETCH_PERIODS';
export const FETCH_PERIODS_SUCCESS = 'FETCH_PERIODS_SUCCESS';
export const SELECT_TAX_YEAR = 'SELECT_TAX_YEAR';
export const SELECT_BOOK_TYPE = 'SELECT_BOOK_TYPE';
export const FETCH_COMPANY_CODE_DETAILS = 'FETCH_COMPANY_CODE_DETAILS';
export const FETCH_COMPANY_CODE_DETAILS_SUCCESS = 'FETCH_COMPANY_CODE_DETAILS_SUCCESS';
export const FETCH_COMPANY_CODE_DETAILS_FAILURE = 'FETCH_COMPANY_CODE_DETAILS_FAILURE';
export const FETCH_CONNECTIONS = 'FETCH_CONNECTIONS';
export const FETCH_CONNECTIONS_SUCCESS = 'FETCH_CONNECTIONS_SUCCESS';
export const SELECT_CONNECTION = 'SELECT_CONNECTION';
export const SELECT_CONNECTION_BY_TYPE = 'SELECT_CONNECTION_BY_TYPE';
export const FETCH_CONNECTIONS_BY_TYPE = 'FETCH_CONNECTIONS_BY_TYPE';
export const FETCH_CONNECTIONS_BY_TYPE_SUCCESS = 'FETCH_CONNECTIONS_BY_TYPE_SUCCESS';
export const FETCH_CONNECTIONS_BY_TYPE_FAILURE = 'FETCH_CONNECTIONS_BY_TYPE_FAILURE';
export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';
export const FETCH_CALCULATION_ID = 'FETCH_CALCULATION_ID';
export const FETCH_CALCULATION_ID_SUCCESS = 'FETCH_CALCULATION_ID_SUCCESS';
export const FETCH_CALCULATION_ID_FAILURE = 'FETCH_CALCULATION_ID_FAILURE';
export const SELECT_CALCULATION = 'SELECT_CALCULATION';

export const SELECT_REPORTING_CURRENCY_CODE = 'SELECT_REPORTING_CURRENCY_CODE';

export const FETCH_ACCOUNTS_STARTED = 'FETCH_ACCOUNTS_STARTED';
export const FETCH_ACCOUNTS_SUCCESS = 'FETCH_ACCOUNTS_SUCCESS';
export const FETCH_ACCOUNTS_FAILURE = 'FETCH_ACCOUNTS_FAILURE';

export const FETCH_BOOK_TYPES_STARTED = 'FETCH_BOOK_TYPES_STARTED';
export const FETCH_BOOK_TYPES_SUCCESS = 'FETCH_BOOK_TYPES_SUCCESS';
export const FETCH_BOOK_TYPES_FAILURE = 'FETCH_BOOK_TYPES_FAILURE';

export const FETCH_USER_CLIENTS_LIST_SUCCESS = 'FETCH_USER_CLIENTS_LIST_SUCCESS';

export const FETCH_COUNTRY_TAX_TYPE_DESCRIPTIONS = 'FETCH_COUNTRY_TAX_TYPE_DESCRIPTIONS';
export const FETCH_COUNTRY_TAX_TYPE_DESCRIPTIONS_SUCCESS = 'FETCH_COUNTRY_TAX_TYPE_DESCRIPTIONS_SUCCESS';
export const FETCH_COUNTRY_TAX_TYPE_DESCRIPTIONS_FAILURE = 'FETCH_COUNTRY_TAX_TYPE_DESCRIPTIONS_FAILURE';
export const RESET_STATE = 'RESET_STATE';

export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';

export const SAVE_ARCHIVE_REPORT = 'SAVE_ARCHIVE_REPORT';
